import { createContext } from "react";

export const PedidosHistorialContext = createContext()
export const PedidosHistorialFormContext = createContext()
export const PedidosHistorialReportContext = createContext()